var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Box",
    { staticClass: "nav-section" },
    [
      _c(
        "Box",
        {
          attrs: { display: "flex", tag: "header", "flex-align": "center" },
          on: {
            click: function($event) {
              _vm.openSection = !_vm.openSection
            }
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c(
            "span",
            { staticClass: "toggle-trigger" },
            [
              _vm.openSection
                ? _c("Icon", { attrs: { name: "angle-down" } })
                : _c("Icon", { attrs: { name: "angle-up" } })
            ],
            1
          )
        ]
      ),
      _c(
        "Box",
        { staticClass: "nav-list", class: { close: _vm.openSection } },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }